import BaseModel from "./BaseModels/BaseModel";
import { AttachContactRequest } from "./Contact";
import { CPE } from "./CPE";
import { DNSSuffix } from "./DNSSuffix";
import { OverallCategoryEnum } from "./enums/OrganisationOverallCategoryEnum";
import { SpecificCategoryEnum } from "./enums/OrganisationSpecificCategoryEnum";
import { RouterTypeEnum } from "./enums/RouterTypeEnum";
import HostingsiteBase from "./Hostingsite";
import { OrganisationContact } from "./OrganisationContact";
import { Subnet } from "./Subnet";
import { Role, UserResponse } from "./User";

export class SimpleBaseOrganisation extends BaseModel {
  name?: string
}

export default class BaseOrganisation extends SimpleBaseOrganisation {
  address = "" 
  cvr = ""
  comment = ""
  overall_category?: OverallCategoryEnum
  specific_category?: SpecificCategoryEnum
  invoice = new Invoice()
}

export class OrganisationResponse extends BaseOrganisation {
}

export class DetailedOrganisationResponse extends OrganisationResponse {
  services_count?: number
  clients_count?: number
  agreements_count?: number
  users_count?: number
  contacts?: OrganisationContact[]
}

export class CreateOrganisationRequest extends BaseOrganisation {
  hosting_sites: CreateOrganisationHostingSiteRequest[] = []
  subnets: OrganisationHostingSiteSubnet[] = []
  routers: OrganisationRouter[] = []
  dnsSuffixes: OrganisationDNSSuffix[] = []
  cpes: OrganisationCPE[] = []
  contacts: OrganisationContact[] = []
  ceos: OrganisationContact[] = []
  organisationalManagers: OrganisationContact[] = []
  financialManagers: OrganisationContact[] = []
  securityManagers: OrganisationContact[] = []
  serviceDesks: OrganisationContact[] = []
}


export class OrganisationRouter extends BaseModel {
  type?: RouterTypeEnum
  name?: string
  ip_address?: string
  username?: string
  password?: string
  comment?: string
}


export class OrganisationDNSSuffix extends BaseModel {
  dns_suffix?: string
  hosting_site?: HostingsiteBase
}

export class OrganisationCPE extends CPE {
  hosting_site?: HostingsiteBase
}

export class OrganisationSmokeping extends BaseModel {
  ip_address?: string
  description?: string

  vpn_peer?: boolean
  icmp_ping?: boolean
  tcp_ping?: boolean
  tcp_portnr?: number
  http_ping?: boolean
  http_url?: number
}

export class Invoice {
  ean?: number
  email = ""
  reference = ""
  debitor = ""
  note = ""
}

export class CreateOrganisationAuthorization extends BaseModel {
  role?: Role
  parentUser?: UserResponse
  organisation?: BaseOrganisation
}

export class OrganisationHostingSiteSubnet extends BaseModel {
  subnet?: string
  hosting_site?: HostingsiteBase
}

export class CreateOrganisationHostingSiteRequest extends BaseModel {
  name?: string
  address?: string
  subnets: Subnet[] = []
  dns_suffixes: DNSSuffix[] = []
  cpes: CPE[] = []
}
